// @flow
import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import server from './serverReducer';
import auth from './authReducer';
import catalog from './catalogReducer';
import cert from './certReducer';
import dirSvc from './dirSvcReducer';
import np from './netPublishReducer';
import roles from './roleReducer';
import rti from './rtiReducer';
import intl from 'portfolio-shared/state/reducers/intlReducer';
import persist from 'portfolio-shared/state/reducers/persistReducer';
import dialogPanel from 'portfolio-shared/state/reducers/dialogPanelReducer';
import modalPrompt from 'portfolio-shared/state/reducers/modalPromptReducer';
import user from './userReducer';
import license from './licenseReducer';
import globalNotifications from 'portfolio-shared/state/reducers/globalNotificationsReducer';
import reachout from 'portfolio-shared/state/reducers/reachoutReducer';
import type { State, Action } from 'state/types';
import { ACTION_TYPE_CLEAR_STATE } from 'state/types/globalTypes';

const reducers = {
  auth,
  catalog,
  cert,
  dialogPanel,
  dirSvc,
  form: formReducer,
  globalNotifications,
  intl,
  license,
  modalPrompt,
  np,
  persist,
  roles,
  reachout,
  rti,
  server,
  user,
};

export type Reducers = typeof reducers;

const appReducer = combineReducers(reducers);

export default function rootReducer(state?: State, action: Action) {
  if (action.type === ACTION_TYPE_CLEAR_STATE) {
    state = undefined;
  }

  return appReducer(state, action);
}



// WEBPACK FOOTER //
// ./src/state/reducers/index.js